import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { LogIn, Lock } from "lucide-react";
import { useAuth } from "../../context/AuthContext";
import { Button } from "../../components/ui/button";
import { Input } from "../../components/ui/input";
import { Label } from "../../components/ui/label";
import { useToast } from "../../hooks/use-toast";
import logoDark from "../../assets/cass-logo-dark.png";

export default function AdminLogin() {
  const { login, user } = useAuth();
  const navigate = useNavigate();
  const { toast } = useToast();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => { if (user) navigate("/admin"); }, [user, navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(username, password);
      navigate("/admin");
    } catch (err) {
      toast({ title: "Login failed", description: "Invalid username or password", variant: "destructive" });
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen numbers-pattern flex items-center justify-center px-6">
      <div className="relative w-full max-w-md">
        <div className="bg-white rounded-3xl shadow-2xl p-8 md:p-10">
          <div className="text-center mb-8">
            <img loading="lazy" decoding="async" src={logoDark} alt="Cloud Accounting Support Services" className="h-20 w-auto mx-auto mb-2" />
            <p className="text-sm text-slate-400">Admin Panel</p>
          </div>

          <form onSubmit={handleSubmit} className="space-y-5">
            <div>
              <Label className="text-navy font-semibold">Username / Email</Label>
              <Input value={username} onChange={(e) => setUsername(e.target.value)} required className="mt-2" autoComplete="username" data-testid="login-username" />
            </div>
            <div>
              <Label className="text-navy font-semibold">Password</Label>
              <Input type="password" value={password} onChange={(e) => setPassword(e.target.value)} required placeholder="••••••••" className="mt-2" autoComplete="current-password" data-testid="login-password" />
            </div>
            <Button type="submit" disabled={loading} data-testid="login-submit" className="w-full bg-orange hover:bg-orange-dark text-white font-bold rounded-full py-6">
              {loading ? "Signing in..." : (<><LogIn size={16} className="mr-2" /> Sign In</>)}
            </Button>
          </form>

          <p className="text-xs text-slate-400 text-center mt-6 flex items-center justify-center gap-1"><Lock size={12} /> Secure area — authorised users only</p>
        </div>
      </div>
    </div>
  );
}
